(function ($) {
  'use strict';

  /**
   * Require confirmation for delete actions
   */
  function DeletionConfirmation() {}

  DeletionConfirmation.prototype = {
    init: function () {
      this.$deletionConfirmationTrigger = $('.js-deletion-confirm');

      if (this.$deletionConfirmationTrigger.length < 1) {
        return;
      }

      this.$deletionConfirmationTrigger.on(
        'click',
        $.proxy(this.onDeletion, this)
      );
    },

    onDeletion: function (e) {
      e.preventDefault();
      var $button = $(e.target);

      var dialog = new Framework.Modal({
        mainEl: document.getElementById('container'), // The element to insert the modal HTML after
        id: 'deletionConfirmation', // A unique Id for this modal
        title:
          $button.attr('data-confirm-message') ||
          'Are you sure you want to delete this item?',
        description:
          $button.attr('data-confirm-submessage') ||
          'This action cannot be undone',
        buttons: [
          {
            text: 'Cancel',
            className: 'btn--outline',
            close: true, // Whether or not this button will close the modal
          },
          {
            text: 'Yes, delete it',
            callback: function () {
              // Submit the form
              var $form = $button.parents('form:first');
              $form.submit();
            },
          },
        ],
      });

      // Show the dialog
      dialog.show();
    },
  };

  this.DeletionConfirmation = DeletionConfirmation;
}.call(Framework, jQuery));
